import { render, staticRenderFns } from "./bookkeeping-statistics.vue?vue&type=template&id=5dcf8570"
import script from "./bookkeeping-statistics.vue?vue&type=script&lang=js"
export * from "./bookkeeping-statistics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports